import { createTheme as t } from "flowbite-react";
const o = t({
  drawer: {
    root: {
      base: "fixed z-[60] overflow-y-auto p-4 transition-transform shadow-lg backdrop-blur-[15px] dark:bg-white/10",
      backdrop: "fixed inset-0 z-50 bg-gray-900/50 dark:bg-intenseDark/50",
      edge: "bottom-16",
      position: {
        top: {
          on: "left-0 right-0 top-0 w-full transform-none",
          off: "left-0 right-0 top-0 w-full -translate-y-full"
        },
        right: {
          on: "right-0 top-0 h-screen w-80 transform-none",
          off: "right-0 top-0 h-screen w-80 translate-x-full"
        },
        bottom: {
          on: "bottom-0 left-0 right-0 w-full transform-none",
          off: "bottom-0 left-0 right-0 w-full translate-y-full"
        },
        left: {
          on: "left-0 top-0 h-screen w-80 transform-none",
          off: "left-0 top-0 h-screen w-80 -translate-x-full"
        }
      }
    },
    header: {
      inner: {
        closeButton: "absolute inset-e-2.5 top-2.5 flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white",
        closeIcon: "h-4 w-4",
        titleCloseIcon: "sr-only",
        titleIcon: "me-2.5 h-4 w-4",
        titleText: "mb-4 inline-flex items-center text-base font-semibold text-gray-500 dark:text-gray-400"
      },
      collapsed: {
        on: "hidden",
        off: "block"
      }
    },
    items: {
      base: ""
    }
  }
}).drawer;
export {
  o as theme
};
